import { PhotoSource } from '@philips-emr/tws-constants';
import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { Changeable, ChangeEventListener } from '@philips-emr/tws-core/lib/component/types';
import { isEnumValid } from '@philips-emr/tws-utils';

class PhotoUploaderAPI extends ComponentAPI implements Changeable<Blob> {
  /** @event */
  @AwesomeEvent
  onChange = new ChangeEventListener<Blob>();

  isEnabled(): boolean {
    return this.state.enabled;
  }

  setEnabled(enabled: boolean): void {
    this.setState({ enabled });
  }

  isPhotoVisible(): boolean {
    return this.state.photoVisible;
  }

  setPhotoVisible(photoVisible: boolean): void {
    this.setState({ photoVisible });
  }

  getSource(): PhotoSource {
    return this.state.source;
  }

  setSource(source: PhotoSource): void {
    if (isEnumValid(PhotoSource, source)) {
      this.setState({ source });
    }
  }

  getTakePhotoExpression(): string {
    return this.state.takePhotoExpression;
  }

  setTakePhotoExpression(takePhotoExpression: string): void {
    this.setState({ takePhotoExpression });
  }

  getValue(): Blob {
    return this.state.value;
  }

  setValue(value: Blob): void {
    const { value: oldValue } = this.state;
    this.setState({ value });

    this.onChange.fire({ value, oldValue });
  }

  isReadOnly(): boolean {
    return this.state.readOnly;
  }

  setReadOnly(readOnly: boolean): void {
    this.setState({ readOnly });
  }
}

export default PhotoUploaderAPI;
